const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const has = (value, key) => Object.prototype.hasOwnProperty.call(value, key);

export function isChatGPTSummaryRecord(row) {
  return isObject(row) && (row.id != null || row.conversation_id != null) &&
    (has(row, 'mapping') || has(row, 'create_time') || has(row, 'update_time') || has(row, 'current_node')) &&
    (row.mapping == null || (isObject(row.mapping) && Object.keys(row.mapping).length === 0));
}

function isConversationRecord(row) {
  return isObject(row) && (has(row, 'mapping') || isChatGPTSummaryRecord(row) ||
    Array.isArray(row.messages) || Array.isArray(row.chat_messages) || Array.isArray(row.responses));
}

// Normalize containers, not message schemas. Only recognized conversation
// records qualify; arbitrary account/project metadata must not become chats.
// Keep original record identity so ID-less chats retain their folder mapping.
export function conversationExportRows(raw, depth = 0) {
  if (Array.isArray(raw)) return raw;
  if (!isObject(raw) || depth > 5) return null;
  if (raw.object === 'conversation_import_archive') return conversationExportRows(raw.conversations, depth + 1);
  if (raw.object === 'account_data_export') return conversationExportRows(raw.data?.conversations, depth + 1);
  if (isConversationRecord(raw)) return [raw];
  for (const field of ['conversations', 'data']) {
    if (has(raw, field)) {
      const rows = conversationExportRows(raw[field], depth + 1);
      if (rows) return rows;
    }
  }
  const rows = Object.values(raw);
  return rows.some(isConversationRecord) ? rows : null;
}

const STRUCTURE_FIELDS = ['object', 'data', 'conversations', 'items', 'id', '_id', 'uuid', 'conversation_id',
  'title', 'name', 'create_time', 'update_time', 'createdAt', 'updatedAt', 'created_at', 'updated_at',
  'current_node', 'mapping', 'messages', 'chat_messages', 'conversation', 'responses'];

// Report only fixed schema names, types and counts. Never echo titles, text,
// IDs, arbitrary object keys (which may be IDs), or other account values.
export function describeConversationImportStructure(raw, depth = 0) {
  if (raw === null) return 'null';
  if (Array.isArray(raw)) {
    const sample = raw.find(isObject);
    return `array(${raw.length})${sample && depth < 3 ? ` of ${describeConversationImportStructure(sample, depth + 1)}` : ''}`;
  }
  if (!isObject(raw)) return typeof raw;
  const fields = STRUCTURE_FIELDS.filter(field => has(raw, field));
  const details = fields.map(field => {
    const value = raw[field];
    const nested = ['data', 'conversations', 'items'].includes(field) && depth < 3;
    const type = nested ? describeConversationImportStructure(value, depth + 1)
      : value === null ? 'null' : Array.isArray(value) ? `array(${value.length})`
        : isObject(value) ? `object(${Object.keys(value).length} fields)` : typeof value;
    return `${field}:${type}`;
  });
  const otherCount = Object.keys(raw).length - fields.length;
  if (otherCount) details.push(`${otherCount} other fields`);
  if (!fields.length && depth < 3) {
    const sample = Object.values(raw).find(isObject);
    if (sample) details.push(`record:${describeConversationImportStructure(sample, depth + 1)}`);
  }
  return `object{${details.join(', ')}}`;
}
